var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBody(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 1080,
    viewBox: "0 0 960 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4928 530.498C25.5062 543.711 8.15122 534.27 7.15656 525.611C5.6759 512.727 46.1236 489.101 96.4993 481.32C108.358 479.269 118.613 478.677 130.71 478.78C157.464 479.007 184.155 483.331 202.726 498.605C207.538 454.753 167.309 429.417 153.448 426.369C114.199 417.741 44.8024 414.608 -4.50779 428.434C-64.3252 450.22 -98.0076 500.627 -94.8687 533.678C-86.3257 564.592 -75.7447 580.59 -22.0741 582.255C6.5042 583.141 46.5298 558.689 47.4928 530.498Z",
    fill: "#FF5B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.215 193.918C218.584 121.33 183.534 -1.64469 148.669 -33.2265C111.635 -66.7742 86.8389 -85.055 27.355 -89.5943C-106.87 -90.2673 -264.653 -26.5358 -368.686 121.232C-536.381 359.424 -615.536 718.434 -581.322 948.295C-565.924 1036.34 -521.386 1093.95 -505.994 1102.41C-491.673 1110.27 -430.624 1023.85 -447.79 958.906C-501.654 781.643 -412.269 408.288 -302.037 240.665C-219.477 115.12 -119.168 32.6209 0.139648 20.8161C35.6539 17.3021 69.0014 19.2811 101.456 34.4362C154.511 59.2109 186.502 120.14 186.215 193.918Z",
    fill: "#FF5B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.5193 84.3494C-178.54 84.3494 -254.331 227.635 -302.377 374.046C-333.819 469.86 -362.924 580.688 -386.025 681.196C-414.017 802.982 -434.712 909.165 -447.79 958.906C-454.142 983.065 -478.213 1069.56 -503.206 1069.56C-525.036 1069.56 -563.948 1018.93 -581.323 948.295C-574.057 996.479 -558.307 1058.88 -529.931 1102.5C-509.313 1134.2 -481.995 1155.79 -446.588 1155.79C-396.431 1155.79 -353.459 1137.94 -313.734 1093.97C-280.073 1056.72 -251.212 998.864 -225.087 912.775C-163.455 709.687 -149.448 638.377 -119.195 538.682C-100.457 476.936 -81.2479 416.668 -59.6321 363.63C-9.29126 240.108 40.4329 185.308 96.6832 156.361C87.3644 121.431 56.9343 84.3494 -24.5193 84.3494Z",
    fill: "#F41D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.368 1131.29C-194.656 1136.47 -271.838 1131.31 -322.361 1083.28C-337.577 1068.49 -349.46 1047.07 -350.066 1018.81C-350.677 990.298 -336.103 952.068 -308.581 932.473C-300.928 965.445 -263.247 1030.46 -164.384 1049.87C-83.4567 1065.76 -20.8162 1046.39 36.1968 999.043C38.1263 1003.03 -56.3002 1125.82 -127.368 1131.29Z",
    fill: "#FF5B00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-322.361 1083.28C-305.89 1099.62 -286.601 1114.85 -264.196 1127.64C-217 1154.58 -157.216 1171.6 -89.5034 1171.6C207.639 1171.6 386.885 885.743 405.919 665.46C415.95 549.369 364.247 469.642 277.606 430.328C241.544 414.267 188.852 402.425 138.847 403.982C88.3945 405.553 26.1601 416.145 -4.50797 428.433C85.5908 416.272 159.019 443.394 186.169 539.365C200.637 590.509 198.794 635.626 196.936 666.939C190.597 773.771 136.39 910.43 36.1965 999.043C-8.58591 1038.65 -62.2066 1071.13 -126.114 1089.95C-199.287 1111.49 -267.515 1113.84 -322.361 1083.28Z",
    fill: "#F41D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.215 193.918C179.901 265.759 164.004 341.456 138.848 403.983C126.882 433.724 112.98 459.16 96.4996 481.32C81.998 500.819 65.4224 517.984 47.4931 530.498C42.4928 533.988 37.4466 535.527 32.1694 538.335C-25.871 569.222 -80.9874 563.318 -94.7385 534.145C-94.3836 575.15 -52.9602 613.036 11.5707 613.036C65.0892 613.036 128.797 591.079 202.286 525.556C228.611 502.086 254.421 468.78 277.607 430.329C319.282 361.213 351.5 274.586 356.037 192.286C358.105 154.764 355.37 115.108 344.207 82.1058C305.872 -31.2223 184.407 -86.4724 27.355 -89.5942C126.462 -76.1444 200.761 28.4151 186.215 193.918Z",
    fill: "#F41D1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M101.456 34.4353C154.509 59.2111 186.501 120.14 186.215 193.917C200.761 28.4144 126.463 -76.1447 27.3571 -89.5947C-106.87 -90.2677 -264.653 -26.5369 -368.684 121.231C-536.38 359.424 -615.538 718.433 -581.325 948.294C-563.947 1018.93 -525.035 1069.56 -503.206 1069.56C-478.214 1069.56 -454.143 983.064 -447.789 958.905C-501.654 781.642 -412.271 408.288 -302.038 240.663C-219.476 115.119 -119.168 32.6202 0.14093 20.8153C35.6527 17.3019 69.0026 19.2805 101.456 34.4353Z",
    fill: "url(#paint0_linear_83_1642)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M32.1688 538.334C37.4452 535.526 42.4923 533.988 47.4917 530.497C25.5046 543.711 8.15092 534.27 7.15647 525.611C5.67582 512.726 46.1221 489.1 96.4982 481.32C104.573 470.464 112.233 458.499 119.13 445.925C104.827 437.748 88.8829 432.14 71.6842 428.967C48.3062 424.654 22.604 424.773 -4.50683 428.433C-64.3251 450.22 -98.0084 500.627 -94.87 533.679C-94.8185 533.85 -94.7626 534.006 -94.7114 534.181C-80.9252 563.319 -25.8444 569.206 32.1695 538.334L32.1688 538.334Z",
    fill: "url(#paint1_linear_83_1642)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M32.1688 538.334C37.4452 535.526 42.4923 533.988 47.4917 530.497C25.5046 543.711 8.15092 534.27 7.15647 525.611C5.67582 512.726 46.1221 489.1 96.4982 481.32C104.573 470.464 112.233 458.499 119.13 445.925C104.866 437.769 88.8305 432.144 71.6842 428.967C48.2696 424.628 22.6569 424.766 -4.50683 428.433C-64.3251 450.219 -98.0084 500.627 -94.87 533.679C-94.8185 533.85 -94.7626 534.006 -94.7114 534.181C-80.9252 563.319 -25.8444 569.206 32.1695 538.334L32.1688 538.334Z",
    fill: "url(#paint2_radial_83_1642)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M-126.115 1089.95C-62.205 1071.13 -8.58344 1038.65 36.1945 999.042C-20.8158 1046.39 -83.4568 1065.76 -164.384 1049.87C-263.245 1030.46 -300.93 965.444 -308.583 932.472C-336.102 952.067 -350.678 990.297 -350.068 1018.81C-349.46 1047.07 -337.579 1068.49 -322.36 1083.28C-267.515 1113.84 -199.285 1111.49 -126.115 1089.95Z",
    fill: "url(#paint3_linear_83_1642)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M-322.361 1083.28C-305.89 1099.62 -286.601 1114.85 -264.196 1127.64C-217 1154.58 -157.216 1171.6 -89.5034 1171.6C207.639 1171.6 386.885 885.743 405.919 665.46C415.95 549.369 364.247 469.642 277.606 430.328C241.544 414.267 188.852 402.425 138.847 403.982C88.3945 405.553 26.1601 416.145 -4.50797 428.433C85.5908 416.272 159.019 443.394 186.169 539.365C200.637 590.509 198.794 635.626 196.936 666.939C190.597 773.771 136.39 910.43 36.1965 999.043C-8.58591 1038.65 -62.2066 1071.13 -126.114 1089.95C-199.287 1111.49 -267.515 1113.84 -322.361 1083.28Z",
    fill: "url(#paint4_linear_83_1642)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M186.215 193.918C179.901 265.759 164.004 341.456 138.848 403.983C126.882 433.724 112.98 459.16 96.4996 481.32C81.998 500.819 65.4224 517.984 47.4931 530.498C42.4928 533.988 37.4466 535.527 32.1694 538.335C-25.871 569.222 -80.9874 563.318 -94.7385 534.145C-94.3836 575.15 -52.9602 613.036 11.5707 613.036C65.0892 613.036 128.797 591.079 202.286 525.556C228.611 502.086 254.421 468.78 277.607 430.329C319.282 361.213 351.5 274.586 356.037 192.286C358.105 154.764 355.37 115.108 344.207 82.1058C305.872 -31.2223 184.407 -86.4724 27.355 -89.5942C126.462 -76.1444 200.761 28.4151 186.215 193.918Z",
    fill: "url(#paint5_linear_83_1642)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M186.215 193.917C179.902 265.758 164.002 341.454 138.846 403.982C188.853 402.425 241.546 414.267 277.606 430.329C319.281 361.213 351.499 274.585 356.037 192.285C358.103 154.762 355.371 115.108 344.207 82.1045C305.872 -31.2239 184.404 -86.4728 27.3568 -89.5948C126.462 -76.1445 200.761 28.4145 186.215 193.917Z",
    fill: "url(#paint6_linear_83_1642)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M11.5687 613.035C33.1531 613.035 56.5154 609.444 81.4329 600.847C113.677 589.722 148.579 570.223 186.168 539.365C177.538 509.02 164.166 485.314 147.177 467.742C138.684 458.958 129.341 451.801 119.129 445.925C112.191 458.545 104.611 470.411 96.4972 481.319C81.9961 500.819 65.4223 517.983 47.491 530.497C42.4914 533.988 37.4443 535.526 32.168 538.334C-25.8724 569.222 -80.989 563.317 -94.7399 534.145C-94.3852 575.149 -52.9629 613.035 11.5687 613.035Z",
    fill: "url(#paint7_linear_83_1642)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M-350.068 1018.81C-350.678 990.297 -336.103 952.067 -308.583 932.472C-304.182 951.44 -289.665 981.154 -259.46 1006.55C-247.406 979.838 -236.03 948.83 -225.087 912.775C-163.455 709.687 -149.448 638.376 -119.195 538.681C-100.457 476.936 -81.2481 416.669 -59.6332 363.629C-9.29297 240.108 40.4338 185.308 96.6818 156.36C87.3647 121.431 56.933 84.3484 -24.5208 84.3484C-178.543 84.3484 -254.331 227.635 -302.378 374.045C-333.819 469.86 -362.926 580.687 -386.027 681.197C-414.017 802.981 -434.711 909.165 -447.789 958.905C-454.144 983.064 -478.215 1069.56 -503.206 1069.56C-525.036 1069.56 -563.948 1018.93 -581.325 948.294C-574.057 996.479 -558.308 1058.88 -529.931 1102.5C-509.314 1134.2 -481.996 1155.79 -446.586 1155.79C-418.21 1155.79 -391.653 1150.08 -366.469 1136.53C-349.193 1127.23 -333.879 1114.95 -319.92 1100.58C-317.283 1097.87 -314.722 1095.15 -312.539 1092.58C-316.062 1089.39 -319.749 1085.87 -322.362 1083.28C-327.351 1078.35 -331.636 1073.2 -335.243 1067.72C-338.676 1062.5 -341.497 1056.96 -343.717 1051.35C-347.468 1041.86 -349.798 1031.39 -350.068 1018.81Z",
    fill: "url(#paint8_linear_83_1642)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M-350.068 1018.81C-350.678 990.297 -336.103 952.067 -308.583 932.472C-304.182 951.44 -289.665 981.154 -259.46 1006.55C-251.687 989.323 -239.027 958.705 -225.087 912.775C-163.455 709.687 -149.448 638.376 -119.195 538.681C-100.457 476.936 -81.2481 416.669 -59.6332 363.629C-9.29297 240.108 40.4338 185.308 96.6818 156.36C87.3647 121.431 56.933 84.3484 -24.5208 84.3484C-178.543 84.3484 -254.331 227.635 -302.378 374.045C-333.819 469.86 -362.926 580.687 -386.027 681.197C-414.017 802.981 -434.711 909.165 -447.789 958.905C-454.144 983.064 -478.215 1069.56 -503.206 1069.56C-525.036 1069.56 -563.948 1018.93 -581.325 948.294C-574.057 996.479 -558.308 1058.88 -529.931 1102.5C-509.314 1134.2 -481.996 1155.79 -446.586 1155.79C-417.754 1155.79 -391.3 1149.9 -366.469 1136.53C-348.935 1127.09 -333.662 1114.69 -319.714 1100.37C-316.937 1097.52 -314.426 1094.96 -312.539 1092.58C-315.742 1089.66 -319.136 1086.49 -322.362 1083.28C-323.474 1082.18 -324.556 1081.06 -325.617 1079.96C-329.148 1076.06 -332.399 1072.04 -335.243 1067.72C-338.623 1062.59 -341.447 1057.07 -343.717 1051.35C-347.672 1041.38 -349.816 1030.54 -350.068 1018.81Z",
    fill: "url(#paint9_radial_83_1642)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_1642",
    x1: -641.303,
    y1: 1392.86,
    x2: 155.849,
    y2: -435.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15418,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21487,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3461,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66512,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83025,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_1642",
    x1: 89.5006,
    y1: 369.041,
    x2: -43.4592,
    y2: 556.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16331,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34707,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74442,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_83_1642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-36.42 249.47) scale(359.235 359.235)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.70797,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89668,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_83_1642",
    x1: -337.499,
    y1: 950.951,
    x2: -70.6856,
    y2: 1075.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03106,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16191,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44485,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61676,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96326,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_83_1642",
    x1: 356.81,
    y1: 187.324,
    x2: -139.015,
    y2: 1325.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14324,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22075,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38833,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63535,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93975,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_83_1642",
    x1: 306.35,
    y1: -175.487,
    x2: -82.0355,
    y2: 713.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17082,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35493,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75017,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93771,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_83_1642",
    x1: 65.543,
    y1: 436.863,
    x2: 133.984,
    y2: 241.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16481,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41633,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96017,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_83_1642",
    x1: 164.848,
    y1: 410.774,
    x2: 57.851,
    y2: 523.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.20076,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4301,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92597,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_83_1642",
    x1: 6.01064,
    y1: -166.745,
    x2: -537.604,
    y2: 1407.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08715,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16896,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34584,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64625,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89365,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_83_1642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-296.109 1034.71) rotate(-125.993) scale(213.434 161.578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15235,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95642,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.f8e2211751e34ee183846ec2538c1a8f.svg";
export { ForwardRef as ReactComponent };